import { Connection } from "~/utils";
import { Application, GetUseCaseResponse } from "~/models/services/app";
import { ApiResponse } from "~/models/services/common";
import Vue from "vue";
import { sdk } from "~/utils/coode-sdk-config";

export class AppService {
    public async getApps(): Promise<Application[]> {
        return (
            await sdk?.core.metaData.request.api.get<
                ApiResponse<GetUseCaseResponse>
            >("use-cases")
        ).data.result.items;
    }
}
